import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJProgressStatus from '../../../../common/components/FJProgressStatus/FJProgressStatus';
import { useSelector, useDispatch } from 'react-redux';

const FJAutoVideoRemoveBgProgressContainer = () => {
    const dispatch = useDispatch();
    const autoRemoverProgress = useSelector(state => state.videoBgRemover.autoRemoverProgress);
    const autoRemoverRoughlyAllTime = useSelector(state => state.videoBgRemover.autoRemoverRoughlyAllTime);
    const autoRemoverStatus = useSelector(state => state.videoBgRemover.autoRemoverStatus);
    const autoProgressThumbnailUrl = useSelector(state => state.videoBgRemover.autoProgressThumbnailUrl);
    const autoEditVideoInfo = useSelector(state => state.videoBgRemover.autoEditVideoInfo);
    const autoEditVideoIsUploading = useSelector(state => state.videoBgRemover.autoEditVideoIsUploading);

    const cancelProgress = () => {
        dispatch(FJActionVideoRemoveBg.cancelAutoRemoverAction());
    };

    const retry = () => {
        dispatch(FJActionVideoRemoveBg.retryAutoRemoverAction());
    };

    const onSourceReload = () => {
        dispatch(FJActionVideoRemoveBg.reloadAutoRemoveSourceAction());
    };

    return (
        <FJProgressStatus
            disabled={autoEditVideoIsUploading}
            progress={autoRemoverProgress}
            allTime={autoRemoverRoughlyAllTime}
            cancelProgress={cancelProgress}
            status={autoRemoverStatus}
            retry={retry}
            thumbnailUrl={autoProgressThumbnailUrl}
            width={autoEditVideoInfo?.width}
            height={autoEditVideoInfo?.height}
            isShowControl={false}
            onSourceReload={onSourceReload}
        />
    );
};

export default FJAutoVideoRemoveBgProgressContainer;
